import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Typo } from '@ers/ui/';

const SlideSwitch = ({ id, name, className, checked, onChange, children, labelPosition, disabled }) => {
    const toggleSwitch = (e) => {
        onChange(e);
    };

    function getSwitchComponents() {
        const labelComponent = (
            <Typo.Body key={`typoId__${id}`} className="switch__label">{children}</Typo.Body>
        );

        let componentsArray = [
            <span key={`switchId__${id}`} className="switch__control">
                <input
                    id={id} name={name} type="checkbox"
                    className="switch__input" checked={checked} onChange={toggleSwitch}
                    disabled={disabled}
                />
                <span className="switch__slider" />
            </span>
        ];
        if (children) {
            componentsArray.push(labelComponent);
        }
        if (labelPosition === 'left') {
            componentsArray = componentsArray.reverse();
        }
        return componentsArray;
    }

    return (
        // <div className={cx('switch', className)}>
        <label htmlFor={id} className={cx('switch', { 'switch--disabled': disabled }, className)}>
            {getSwitchComponents()}
        </label>
        // </div>
    );
};

SlideSwitch.propTypes = {
    id: PropTypes.number.isRequired,
    onChange: PropTypes.func.isRequired,
    checked: PropTypes.bool.isRequired,
    labelPosition: PropTypes.oneOf(['left', 'right']),
    name: PropTypes.string,
    className: PropTypes.string,
    disabled: PropTypes.bool,
};

SlideSwitch.defaultProps = {
    className: null,
    name: '',
    labelPosition: 'left',
    disabled: false,
};

export default SlideSwitch;

